(function () {
  if (!('IntersectionObserver' in window)) return;

  // Update only if your structure changes. For your markup this matches the visible button element.
  var buttonSelector = '.load-more .button';

  var observer = null;
  var loading = false;
  var attachRoot = document.body; // Change to a closer parent if you want fewer mutations observed
  var rootMargin = '400px'; // start loading before it's fully visible. set '0px' to only trigger when visible.

  function findButton() {
    return document.querySelector(buttonSelector);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var btn = entry.target;
      if (!btn || loading) return;

      // If the "Load more" button is visually disabled by your theme, avoid triggering.
      if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;

      loading = true;

      // Try to trigger the theme's existing load-more behavior by clicking the button.
      try {
        btn.click();
      } catch (e) {
        // Fallback synthetic click
        var ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        btn.dispatchEvent(ev);
      }

      // If your theme emits an event after loading completes, listen to that and set loading=false there.
      // Example (uncomment and replace with your real event):
      // document.addEventListener('products:loaded', function () { loading = false; });

      // Fallback timeout to reset loading if no event fires (adjust to expected load duration)
      setTimeout(function () { loading = false; }, 3000);
    });
  }

  function attachObserverToButton(btn) {
    if (!btn) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(onIntersect, {
      root: null,
      rootMargin: rootMargin,
      threshold: 0.01
    });
    observer.observe(btn);
  }

  function init() {
    var btn = findButton();
    if (btn) attachObserverToButton(btn);

    // Watch for DOM changes so we can reattach if the theme replaces the button after loading.
    var mo = new MutationObserver(function (mutations) {
      var newBtn = findButton();
      if (newBtn && (!observer || !isObserved(newBtn))) {
        attachObserverToButton(newBtn);
      }

      // Optional: detect when spinner disappears to clear loading flag more reliably.
      // If your theme shows .load-more_spinner while loading, we can reset loading once it's hidden/removed.
      var spinner = document.querySelector('.load-more_spinner');
      if (!spinner) {
        loading = false;
      } else {
        // If spinner is present but not visible, treat as not loading
        var style = window.getComputedStyle(spinner);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
          loading = false;
        }
      }
    });

    mo.observe(attachRoot, { childList: true, subtree: true });
  }

  function isObserved(node) {
    // crude check: IntersectionObserver doesn't expose observed targets, so check if node is in document
    return document.contains(node);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();